<template>
    <div>
        <ul class="dock-pull-list" v-if="query">
            <li class="dock-pull-list-event">
                <div class="dock-pull-list-text">
                    <div class="dock-pull-list-header">
                        <a class="a-link" @click="deleteQuery()">{{query_message}} <i class="far fa-times"></i></a>
                    </div>
                </div>
            </li>
        </ul>
        <grid class="c-m g-m">
            <row :reverse="!1" middle="xs" center="xs">
                <column :xs="9"><input type="search" class="dock-pull-input" @keydown.enter="searchValues()" :placeholder="$t('events.search_label')" v-model="filterValue"></column>
                <column :xs="3"><button class="dock-pull-button" @click="searchValues()"><i class="far fa-search"></i></button></column>
            </row>
        </grid>
        <SortedTable v-if="events.length" :values="events" dir="desc">
            <thead>
            <tr>
                <th scope="col">
                    <SortLink name="name">{{$t('events.name_label')}}</SortLink>
                </th>
                <th scope="col">
                    <SortLink name="date">{{$t('date_label')}}</SortLink>
                </th>
                <th scope="col" colspan="2">
                    <SortLink name="obj_name">{{$t('events.object_label')}}</SortLink>
                </th>
            </tr>
            </thead>
            <tbody slot="body" slot-scope="sort">
            <tr v-for="event in sort.values" :key="event.id">
                <td class="device-link" @click.stop="addFilterValue(event.name)">{{event.name | truncate(20)}}</td>
                <td class="device-link" @click.stop="addFilterValue($moment(event.date).format($t('short_date_format')))">{{event.date | moment($t('short_date_format'))}}</td>
                <td class="device-link"  @click.stop="addFilterValue(event.obj_name)">{{event.obj_name | truncate(12)}}</td>
                <td class="device-link"  @click.stop="checkEvent(event)"><i class="far fa-location-arrow"></i></td>
            </tr>
            </tbody>
        </SortedTable>
        <ul class="dock-pull-list" v-else>
            <li class="dock-pull-list-event">
                <div class="dock-pull-list-text">
                    <div class="dock-pull-list-header">
                        <b>{{$t('events.no_data_label')}}</b>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'Events',
  props: ['query'],
  data () {
    return {
      filterValues: [],
      tmp: []
    }
  },
  computed: {
    ...mapGetters({
      getEvents: 'getFilteredEvents',
      objectTree: 'getObjectFromTree',
      history: 'getHistory'
    }),
    filterValue: {
      get () {
        return this.filterValues.join(';')
      },
      set (val) {
        if (val) {
          this.filterValues = val.split(';')
        } else {
          this.filterValues = []
        }
      }
    },
    events () {
      return this.getEvents(this.query, this.tmp, ['obj_name', 'name', 'date'])
    },
    query_message () {
      switch (this.query) {
        case 'geo_zone':
          return this.$t('reports.type.geo')
        case 'no_response':
          return this.$t('reports.type.offline_days')
        default: return undefined
      }
    }
  },
  methods: {
    deleteQuery () {
      this.$router.replace({'query': null})
    },
    addFilterValue (n) {
      this.filterValues.push(n)
    },
    searchValues () {
      this.tmp = [...this.filterValues]
    },
    ...mapActions(['getObjectsEvents']),
    ...mapActions({
      curObj: 'setCurrentDevice'
    }),
    ...mapMutations(['updateFootprint', 'dockVisibility']),
    checkEvent (event) {
      this.updateFootprint({
        ...event,
        desc: event.name,
        name: event.obj_name
      })
      const obj = this.objectTree(event.imei)
      this.curObj({
        idx: obj.idx,
        idxg: obj.idxg,
        id: obj.obj.id,
        group_id: obj.obj.group_id
      }).then(() => {
        this.dockVisibility(false)
        this.$router.push({name: 'Quick'})
      })
    }
  },
  created () {
    this.getObjectsEvents(false)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/events/Events.vue